import React from 'react';

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string; // aria-label obligatoire
  disabled?: boolean;
}

/**
 * Toggle switch conforme DS Sillant :
 * - off : bg-gray-200 thumb blanc
 * - on  : bg-violet-600 thumb blanc
 * Taille fixe 36×20 px.
 */
const Switch: React.FC<Props> = ({ checked, onChange, label, disabled }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex items-center shrink-0 w-9 h-5 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2 ${
        checked ? 'bg-violet-600' : 'bg-gray-200'
      } ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`inline-block w-4 h-4 bg-white rounded-full shadow-sm transform transition-transform ${
          checked ? 'translate-x-[18px]' : 'translate-x-0.5'
        }`}
        aria-hidden
      />
    </button>
  );
};

export default Switch;
